import { I2PEnvironment } from '@price-for-profit/micro-services';
import { CONTROLLER_BRAND_EMAILS } from 'shared/constants';
import { AppPermission, UserInfo } from 'shared/types';

export const getAppPermissions = (InsightClaims: string) => {
  return InsightClaims.split(' ').filter(p => p.startsWith('abg-retail') || p.startsWith('fas')) as AppPermission[];
};

export const checkPermissions = (userPermissions: AppPermission[]) => (...permissions: AppPermission[]) =>
  permissions.every(permission => userPermissions.includes(permission));

export const getUserInfoFromIdClaims = ({
  given_name,
  family_name,
  name,
  email,
  sub,
  InsightClaims,
}: Record<string, string>): UserInfo => ({
  firstName: given_name,
  lastName: family_name,
  email,
  displayName: name || `${given_name} ${family_name}`,
  id: sub,
  insightClaims: InsightClaims,
});

export const getControllerUserBrand = (environment: I2PEnvironment, user: UserInfo | null) => {
  const brands = Object.getOwnPropertyNames(CONTROLLER_BRAND_EMAILS[environment]);
  const userBrands: string[] = [];
  if (user) {
    brands.forEach(brand => {
      if (brand) {
        if (
          CONTROLLER_BRAND_EMAILS[environment][brand] &&
          CONTROLLER_BRAND_EMAILS[environment][brand].includes(user.email)
        ) {
          userBrands.push(brand);
        }
      }
    });
  }
  return userBrands;
};
